(() => {
  document.querySelectorAll('[data-hh-mega]').forEach((el) => {
    if (el.dataset.hhReady) return;
    el.dataset.hhReady = 'true';

    const trigger = el.querySelector('.hh-mega__trigger');
    let timer;
    let pointerType = 'mouse';
    let suppressFocus = false;

    const setOpen = (state) => {
      clearTimeout(timer);
      el.classList.toggle('is-open', state);
      trigger.setAttribute('aria-expanded', state ? 'true' : 'false');
    };
    const closeSoon = () => {
      clearTimeout(timer);
      timer = setTimeout(() => setOpen(false), 200);
    };

    // Mouse: open on hover, close with a short delay so the cursor can travel to the panel
    el.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') setOpen(true); });
    el.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') closeSoon(); });

    // Touch at desktop widths (iPad): first tap opens, second tap goes to Shop
    el.addEventListener('pointerdown', (e) => { pointerType = e.pointerType; });
    trigger.addEventListener('click', (e) => {
      if (pointerType !== 'mouse' && !el.classList.contains('is-open')) {
        e.preventDefault();
        setOpen(true);
      }
    });

    // Keyboard
    el.addEventListener('focusin', () => { if (!suppressFocus) setOpen(true); });
    el.addEventListener('focusout', (e) => { if (!el.contains(e.relatedTarget)) setOpen(false); });
    el.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && el.classList.contains('is-open')) {
        setOpen(false);
        suppressFocus = true;
        trigger.focus();
        suppressFocus = false;
      }
    });

    // Tap or click outside closes it
    document.addEventListener('pointerdown', (e) => { if (!el.contains(e.target)) setOpen(false); });
  });
})();